/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dispatch } from 'react';

import { IListGameReturn } from '../interfaces/game';
import { GameStatusManager } from '../services/manager';
import { getAllGames, getGameBySport } from '../services/game';
import { listGameActions } from './definition';

function gameError(e: string, commune: any) {
    return {
        type: listGameActions.LIST_GAME_ERROR,
        error: e,
        data: commune,
    };
}

// Reducers of Single Game
function gameIsLoading() {
    return {
        type: listGameActions.LIST_GAME_IS_LOADING,
    };
}

const gameListReset = () => {
    return {
        type: listGameActions.LIST_GAME_RESET,
    };
};

// Recuders of Game Collection
function gameIsLoadingList() {
    return {
        type: listGameActions.LIST_GAME_IS_LOADING,
    };
}

function gameErrorList(e: string) {
    return {
        type: listGameActions.LIST_GAME_ERROR,
        error: e,
    };
}

function gameSetList(games: any) {
    return {
        type: listGameActions.LIST_GAME,
        data: games,
    };
}

/**
 * Reducer to rest a games
 * @param values Data to reset games
 */
export const resetStateGame = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(gameListReset());
    };
};

/**
 * Reducer to rest a games
 * @param values Data to reset games
 */
export const resetGameReset = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(gameListReset());
    };
};

/**
 * Reducer to reset Games
 * @param values Values to reset games
 */
export const resetGame = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(gameListReset());
    };
};

// List

/**
 * Reducer to get all the games
 */
export const fetchListGames = (paginate = 1, limit = 999, search = '') => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(gameIsLoadingList());
        await getAllGames(paginate, limit, search)
            .then((response: IListGameReturn) => {
                if (response.statusCode === GameStatusManager.GAMES_LISTED) {
                    dispatch(gameSetList(response.data));
                } else {
                    dispatch(gameErrorList(response.message));
                }
            })
            .catch((error) => {
                dispatch(gameErrorList(error));
            });
    };
};

/**
 * Reducer to get a game by id
 * @param id Id of game to find
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getGameBysport = (query) => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(gameIsLoading());
        try {
            const response = await getGameBySport(query);
            if (response?.statusCode === GameStatusManager.GAMES_LISTED && response.data) {
                dispatch(gameSetList(response));
            } else {
                dispatch(gameError('Could not get game: ', query.sport));
            }
        } catch (error: any) {
            const Err = {
                data: query,
                message: error,
                code: 'NOT_FOUNT',
            }
            dispatch(gameError('No se pudo obtener el game', Err ));
        }
    };
};
